import { Box, Text, Timeline } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { noop } from '@wix/seo-common-core';
import React from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../../hooks/use-open-article-by-editor-host';
import { TextButtonComp } from './color-contrast-incomplete-element-content';
export const ColorContrastIncompleteElementTimeline = _ref => {
  let {
    locale,
    minimalRatio,
    elementIndex,
    status
  } = _ref;
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const onArticleClick = (articleKey, _ref2) => {
    let {
      ctaName,
      index,
      elementStatus
    } = _ref2;
    openSelectedArticle(editorHost, articleKey);
    biLogger.taskElementCtaClick({
      ctaName,
      index,
      status: elementStatus
    });
  };
  const firstStep = /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "6px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, t('accessibility-wizard.rules-list.color-contrast.element.incomplete.first-item.title')), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, t('accessibility-wizard.rules-list.color-contrast.element.incomplete.first-item.content')));
  const secondStep = /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "6px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, t('accessibility-wizard.rules-list.color-contrast.element.incomplete.second-item.title')), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      article1: /*#__PURE__*/React.createElement(TextButtonComp, {
        onClick: () => onArticleClick('editor-package-accessibility-wizard.articles-incomplete-components-help.contrast-checker', {
          ctaName: BiCtaNames.ContrastChecker,
          elementStatus: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed,
          index: elementIndex
        })
      }),
      article2: /*#__PURE__*/React.createElement(TextButtonComp, {
        onClick: () => onArticleClick('', {
          ctaName: BiCtaNames.LearnMore,
          elementStatus: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed,
          index: elementIndex
        })
      }),
      boldText: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: "accessibility-wizard.rules-list.color-contrast.element.incomplete.second-item.content",
    values: {
      minimalRatio: new Intl.NumberFormat(locale).format(minimalRatio)
    }
  })));
  const items = [{
    label: firstStep
  }, {
    label: secondStep
  }, {
    customPrefix: noop,
    label: ''
  }];
  return /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: items,
    skin: "dark"
  });
};
//# sourceMappingURL=color-contrast-incomplete-element-timeline.js.map